module.exports = require('./helpers/bundle-url').getBundleURL('6GpEv') + "logo.c51670a8.svg";